import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import KitSelectStyle from './ExpansionKitSelection.module.css'
import renderImage from '../../source/importImg'
import getBackendImage from '../../source/imageUtil'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { setLanguageSelect } from '../../redux/actions'
import { connect } from 'react-redux'
import { languageMenu } from '../../utils/langaugeSupport'
import { getVersionArguments } from '../../utils/verionControl'
import { fetchVersion } from './FlashFiles'
import KitSelectionHeader from '../ReusableComponents/Header/KitSelectionHeader'
import { EXPANSION_KITS } from '../../utils/expansionKits'

const BACKEND_URL = process.env.REACT_APP_API_BASE

// Device cards a user can pick from (copied from the "Codable Modules" tab in kitTabs)
const DEVICE_CARDS = {
    Toki: { device: 'Toki', name: 'Toki', src: 'toki' },
    Poki: { device: 'Poki', name: 'Poki', src: 'tokiPlus' },
    Moki: { device: 'Moki', name: 'Moki', src: 'moki' },
}

const ExpansionKitSelection = (props) => {
    const [supportedDevice, setSupportedDevice] = useState([])
    const [filteredResults, setFilteredResults] = useState({})
    const [expansionKitObj, setExpansionKitObj] = useState({})
    const [showLanguagePopup, setShowLanguagePopup] = useState(false)
    const [languageValue, setLanguageValue] = useState(props.device.language)

    // Once a device is picked we show its subprograms in place of the device cards
    const [selectedDevice, setSelectedDevice] = useState(null)
    const [subprograms, setSubprograms] = useState([])
    const [subLoading, setSubLoading] = useState(false)

    const history = useHistory()
    const location = useLocation()

    // The expansion kit id comes in via ?expansionKitDevice=<id>
    const expansionKitId = new URLSearchParams(location.search).get(
        'expansionKitDevice'
    )

    useEffect(() => {
        const kit = EXPANSION_KITS[expansionKitId]
        if (!kit) {
            setSupportedDevice([])
            setExpansionKitObj({})
            return
        }

        setExpansionKitObj({ name: kit.name, src: kit.src })
        setSupportedDevice(
            kit.devices.map((d) => DEVICE_CARDS[d]).filter(Boolean)
        )
    }, [expansionKitId])

    const handleAutoConnection = () => {
        history.push('/deviceSelection')
    }

    const handleDeviceConnection = async (item, allowAutoSkip = true) => {
        sessionStorage.setItem('connectedDevice', item.device)
        sessionStorage.setItem('allowedDevice', item.device)

        // Fetch the latest version for the selected device
        try {
            let { latestVersion } = await fetchVersion(
                getVersionArguments[item.device]
                    ? getVersionArguments[item.device].deviceName
                    : 'Playcomputer',
                getVersionArguments[item.device]
                    ? getVersionArguments[item.device].version
                    : '1.0'
            )
            sessionStorage.setItem(
                'deviceVersion',
                latestVersion.slice(0, latestVersion.length - 2)
            )
        } catch (error) {
            console.error('Failed to fetch version:', error)
            sessionStorage.setItem('deviceVersion', '1')
        }

        // Keep the make flow in sync with the chosen expansion kit
        if (expansionKitId) {
            sessionStorage.setItem('expansionKit', expansionKitId)
        }

        // Instead of navigating away, show this device's subprograms in place
        setSubLoading(true)
        try {
            const res = await fetch(
                `${BACKEND_URL}/api/program/${item.device.toLowerCase()}`
            )
            const data = await res.json()
            // When entered via an expansion kit, only show that kit's subprograms
            const visible = (data?.subprograms || []).filter(
                (sub) => !expansionKitId || sub.kit === expansionKitId
            )

            // If the device has exactly one kit, skip the selection screen and
            // open it directly (session storage was already set above).
            // Skipped when restoring from a back navigation, otherwise the
            // kitMenu back button would bounce straight forward again.
            if (allowAutoSkip && visible.length === 1) {
                // Remember we skipped the kit list, so kitMenu's back button
                // returns to the device list rather than the (single) kit card.
                sessionStorage.setItem('expansionKitAutoSkipped', 'true')
                openSubprogram(visible[0].id)
                return
            }

            sessionStorage.removeItem('expansionKitAutoSkipped')
            setSelectedDevice(item)
            setSubprograms(visible)
        } catch (err) {
            console.error('Failed to load program:', err)
            sessionStorage.removeItem('expansionKitAutoSkipped')
            setSelectedDevice(item)
            setSubprograms([])
        } finally {
            setSubLoading(false)
        }
    }

    const openSubprogram = (subId) => {
        // history.push(`/make/${subId}`)
        history.push(`/kitMenu?subprogramId=${subId}`)
    }

    // When returning from kitMenu (?device=<device>), reopen the subprogram
    // cards for that device instead of the device list
    useEffect(() => {
        const restoreDevice = new URLSearchParams(location.search).get('device')
        if (restoreDevice && DEVICE_CARDS[restoreDevice]) {
            // Don't auto-skip on restore, or the kitMenu back button would
            // immediately navigate forward into the single kit again.
            handleDeviceConnection(DEVICE_CARDS[restoreDevice], false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const languageActionHandel = () => {
        props.setLanguageSelect({ language: languageValue })
        setShowLanguagePopup(false)
    }

    const gobackUrl = () => {
        // When viewing subprograms, step back to the device list first
        if (selectedDevice) {
            setSelectedDevice(null)
            setSubprograms([])
            return
        }
        sessionStorage.setItem('slideDirection', true)
        history.push('/kitSelection')
    }

    return (
        <>
            <DialogModal
                show={showLanguagePopup}
                text={
                    <div>
                        <p>Select Your Prefer language</p>
                        <div>
                            <select
                                className={KitSelectStyle.language_select}
                                value={languageValue}
                                onChange={(e) =>
                                    setLanguageValue(e.target.value)
                                }
                            >
                                {languageMenu.map((ele) => {
                                    return <option value={ele}>{ele}</option>
                                })}
                            </select>
                        </div>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setShowLanguagePopup(false)}
                optionsToSelect={[
                    {
                        text: 'CONTINUE',
                        do: () => {
                            languageActionHandel()
                        },
                    },
                ]}
            />
            <KitSelectionHeader
                setShowLanguagePopup={setShowLanguagePopup}
                setFilteredResults={setFilteredResults}
                filteredResults={filteredResults}
                supportedDevice={supportedDevice}
            />

            <div className={KitSelectStyle.container}>
                <div className={KitSelectStyle.Connect_Body}>
                    <div
                        className={KitSelectStyle.sidebar}
                        style={{ padding: '1.25rem 0' }}
                    >
                        <div className={KitSelectStyle.sidebarCardParent}>
                            <div className={KitSelectStyle.sidebarCard}>
                                <div className={KitSelectStyle.cardImg}>
                                    <img
                                        src={renderImage(expansionKitObj.src)}
                                        alt={expansionKitObj.src}
                                    />
                                </div>
                                <p className={KitSelectStyle.cardName}>
                                    {expansionKitObj.name}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={KitSelectStyle.content}>
                        <p className={KitSelectStyle.contentPara}>
                            {selectedDevice
                                ? 'Select a kit for this device'
                                : 'Select a device'}
                        </p>
                        <div>
                            {selectedDevice ? (
                                <div className={KitSelectStyle.tabContent}>
                                    {subLoading ? null : subprograms.length ===
                                      0 ? (
                                        <p
                                            style={{
                                                gridColumn: '1 / -1',
                                                textAlign: 'center',
                                                padding: '40px',
                                                color: '#888',
                                            }}
                                        >
                                            No projects available yet.
                                        </p>
                                    ) : (
                                        subprograms.map((sub) => (
                                            <div
                                                key={sub.id}
                                                onClick={() =>
                                                    openSubprogram(sub.id)
                                                }
                                                className={KitSelectStyle.card}
                                            >
                                                <div
                                                    className={
                                                        KitSelectStyle.cardImg
                                                    }
                                                >
                                                    <img
                                                        src={getBackendImage(
                                                            sub.image ||
                                                                'projectDefault'
                                                        )}
                                                        alt={sub.title}
                                                    />
                                                </div>
                                                <p
                                                    className={
                                                        KitSelectStyle.cardName
                                                    }
                                                >
                                                    {sub.title}
                                                </p>
                                            </div>
                                        ))
                                    )}
                                </div>
                            ) : filteredResults &&
                            Object.keys(filteredResults).length > 0 ? (
                                <div className={KitSelectStyle.tabContent}>
                                    <div
                                        onClick={() =>
                                            handleDeviceConnection(
                                                filteredResults
                                            )
                                        }
                                        className={KitSelectStyle.card}
                                    >
                                        <div className={KitSelectStyle.cardImg}>
                                            <img
                                                src={renderImage(
                                                    filteredResults.src
                                                )}
                                                alt={filteredResults.src}
                                            />
                                        </div>
                                        <p className={KitSelectStyle.cardName}>
                                            {filteredResults.name}
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div className={KitSelectStyle.tabContent}>
                                    {supportedDevice.map((ele, ind) => (
                                        <div
                                            key={ind}
                                            onClick={() =>
                                                handleDeviceConnection(ele)
                                            }
                                            className={KitSelectStyle.card}
                                        >
                                            <div
                                                className={
                                                    KitSelectStyle.cardImg
                                                }
                                            >
                                                <img
                                                    src={renderImage(ele.src)}
                                                    alt={ele.src}
                                                />
                                            </div>
                                            <p
                                                className={
                                                    KitSelectStyle.cardName
                                                }
                                            >
                                                {ele.name}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className={KitSelectStyle.Connect_Footer}>
                    <div>
                        <img
                            style={{ width: '90px', cursor: 'pointer' }}
                            src={renderImage('auto')}
                            alt="arrowRight"
                            onClick={handleAutoConnection}
                        />
                    </div>
                </div>

                <img
                    onClick={() => gobackUrl()}
                    // className="nextButton" //search for ".nextButton" in project directory to edit style
                    id="uploadLogicscrn"
                    src={renderImage('backBtn')}
                    style={{
                        position: 'absolute',
                        visibility: 'visible',
                        // top: '91%',
                        bottom: '4%',
                        left: '2%',
                        width: '60px',
                        // height: '60px',
                        cursor: 'pointer',
                        opacity: '1',
                    }}
                ></img>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        setLanguageSelect: (data) => {
            dispatch(setLanguageSelect(data))
        },
        setSocket: (data) => {
            dispatch({ type: 'SOCKET', payload: data })
        },
        setSelectedKit: (data) => {
            dispatch({ type: 'SET_SELECTED_KIT', payload: data })
        },
        setActiveTab: (data) => {
            dispatch({ type: 'SET_ACTIVE_TAB', payload: data })
        },
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExpansionKitSelection)
